import React from 'react';

const Twitter = () => (
  <svg viewBox="0 0 20 20" fill="currentColor">
    <path d="M17.15,6.62c0,.14,0,.29,0,.43,0,4.51-3.71,9.7-10.5,9.7A11,11,0,0,1,1,15.22a6.4,6.4,0,0,0,.88,0,7.88,7.88,0,0,0,4.58-1.45A3.72,3.72,0,0,1,3,11.44a3.26,3.26,0,0,0,.7.06,3.8,3.8,0,0,0,1-.11A3.51,3.51,0,0,1,1.72,8V8a3.89,3.89,0,0,0,1.67.42A3.35,3.35,0,0,1,1.75,5.59a3.29,3.29,0,0,1,.5-1.72A10.77,10.77,0,0,0,9.86,7.43a3.27,3.27,0,0,1-.09-.78,3.56,3.56,0,0,1,3.69-3.4,3.83,3.83,0,0,1,2.7,1.08A8,8,0,0,0,18.5,3.5a3.45,3.45,0,0,1-1.63,1.88A7.92,7.92,0,0,0,19,4.85,7.09,7.09,0,0,1,17.15,6.62Z" />
  </svg>
);

export default Twitter;
